/* CUBE STORE - l'ordine sotto il prezzo

   Come deve leggersi la colonna:

     prezzo del prodotto
     rata HeyLight a tasso zero
     widget seQura        (installato, in attesa di attivazione loro)
     banner del buono bonifico

   PERCHE' SERVE UNO SPOSTAMENTO
   I tre pezzi nascono in due posti diversi e non si possono ordinare
   con il CSS. Il banner del buono e' un <aside class="cube-voucher">
   che il tema disegna DENTRO l'elemento <product-price>, mentre la
   rata e l'aggancio di seQura stanno nel blocco "Widget pagamenti"
   che viene subito dopo. Sono su due rami diversi dell'albero: order
   e flex non li possono incrociare.

   Quindi si portano rata e seQura dentro <product-price>, appena prima
   del banner. Un solo spostamento, e l'ordine viene da se'.

   IL BANNER NON SI TOCCA
   Resta dov'e' e come lo disegna il tema: si infilano gli altri due
   davanti a lui. Spostare il banner avrebbe voluto dire ricordarsi
   dove rimetterlo, e il tema lo ridisegna al cambio taglia.

   PERCHE' GIRA A OGNI MODIFICA DEL DOM
   Il blocco prezzo viene ricostruito quando si cambia taglia, e
   l'aggancio di seQura potrebbe riempirsi dopo il caricamento. Il
   guardiano dataset evita di rifare lo spostamento all'infinito - ed
   e' anche cio' che impedisce all'osservatore di rincorrere le proprie
   modifiche. */
(function () {
  function sistema() {
    var prezzo = document.querySelector('product-price');
    if (!prezzo) return;

    var rata = document.querySelector('.cube-rata');
    var sequra = document.querySelector('.cube-widget-sequra');
    if (!rata && !sequra) return;

    /* gia' a posto: non si tocca niente, altrimenti l'osservatore
       riparte a ogni giro */
    if ((!rata || rata.parentElement === prezzo) &&
        (!sequra || sequra.parentElement === prezzo)) return;

    var buono = prezzo.querySelector('.cube-voucher');

    /* senza banner si accodano in fondo al blocco prezzo: l'ordine
       fra loro due resta comunque quello giusto */
    if (rata) {
      if (buono) prezzo.insertBefore(rata, buono);
      else prezzo.appendChild(rata);
    }

    if (sequra) {
      if (buono) prezzo.insertBefore(sequra, buono);
      else prezzo.appendChild(sequra);
    }

    /* seQura va DOPO la rata: inserendo prima la rata e poi seQura
       davanti al banner, seQura finirebbe fra le due. Si rimette in
       coda alla rata. */
    if (rata && sequra && rata.nextElementSibling !== sequra) {
      rata.insertAdjacentElement('afterend', sequra);
    }
  }

  var inCoda = false;
  function programma() {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      sistema();
    });
  }

  function init() {
    sistema();
    if (!document.body) return;
    new MutationObserver(programma).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
